export const translations = {
  fr: {
    nav: {
      home: "Accueil", chambres: "Chambres d'hôtes", gites: "Gîtes",
      seminaires: "Séminaires et groupes", domaine: "Le Domaine", region: "La région",
      infos: "Informations pratiques", contact: "Contact", reserver: "Réserver", sejours: "Nos séjours",
      giftcards: "Bons cadeaux", boutique: "Boutique",
    },
    boutiquePage: {
      tag: "Boutique du domaine",
      title: "Un coin boutique aux couleurs de la Bretagne",
      subtitle: "Repartez avec un morceau de Bretagne : gourmandises locales et petits souvenirs, en vente à l'accueil du domaine.",
      note: "En vente sur place, à l'accueil du domaine",
      empty: "Notre sélection arrive très bientôt.",
      allCategories: "Tout",
    },
    packages: {
      title: "Nos séjours à vivre", subtitle: "Des expériences pensées pour vous",
      from: "à partir de", cta: "Réserver ce séjour", included: "Inclus",
      items: [
        { title: "Escapade romantique", tagline: "Une parenthèse à deux au calme de la baie.",
          includes: ["1 à 2 nuits en chambre cosy", "Petit déjeuner", "Panier gourmand", "Idées balades au coucher du soleil"] },
        { title: "Week-end rando GR34", tagline: "Le sentier des douaniers au départ du domaine.",
          includes: ["Nuit(s) au domaine", "Panier pique-nique breton", "Itinéraires GR34 conseillés", "Départ tardif possible"] },
        { title: "Séjour Mont-Saint-Michel", tagline: "À la découverte de la Merveille de l'Occident.",
          includes: ["Hébergement au cœur de la baie", "Conseils horaires des marées", "Bonnes adresses pour visiter", "Parking gratuit sur place"] },
      ],
    },
    badges: {
      title: "Nos engagements",
      items: ["Petit déjeuner maison", "Produits locaux", "Wi-Fi gratuit", "Parking gratuit"],
    },
    directBanner: {
      text: "Réservez en direct : meilleur prix garanti, sans commission",
      badge: "jusqu'à -20% vs Airbnb & Booking",
    },
    reassurance: {
      items: ["Annulation gratuite selon conditions", "Confirmation immédiate", "Paiement 100% sécurisé"],
    },
    onsite: {
      tag: "La vie à la Bégaudière",
      title: "Un petit coin boutique sur place",
      text: "Le domaine, c'est aussi un lieu qui vit. À l'accueil, retrouvez une sélection de produits du terroir breton, de créations d'artisans locaux et de petits souvenirs à rapporter, pour prolonger un peu la Bretagne une fois rentré à la maison.",
      items: ["Produits du terroir breton", "Créations d'artisans locaux", "Souvenirs de la baie", "Idées cadeaux"],
      note: "À découvrir sur place, à l'accueil du domaine.",
    },
    bikeRental: {
      tag: "Sur place",
      title: "Location de vélos",
      text: "Explorez la baie du Mont-Saint-Michel et les chemins de campagne à votre rythme. Nous proposons à la location des vélos adultes et enfants directement au domaine, idéal pour une balade en famille jusqu'aux marais ou vers Dol-de-Bretagne.",
      adult: "Vélo adulte",
      child: "Vélo enfant",
      halfDay: "Demi-journée",
      fullDay: "Journée entière",
      adultHalf: "10 €", adultFull: "15 €",
      childHalf: "10 €", childFull: "13 €",
      note: "Réservation sur place, selon disponibilité. Casque en option : 5 € / jour.",
    },
    giftPage: {
      title: "Offrez un séjour",
      subtitle: "Le cadeau parfait pour vos proches",
      crumb: "Bons cadeaux",
      intro: "Offrez un moment de détente au Domaine de La Bégaudière. Choisissez un montant, personnalisez votre message : le bon cadeau est disponible immédiatement en PDF, prêt à offrir.",
      chooseAmount: "Choisissez un montant",
      customAmount: "Autre montant (libre)",
      customPlaceholder: "Entrez un montant",
      customError: "Montant entre {min} et {max} €",
      buyerName: "Votre nom", buyerEmail: "Votre e-mail",
      recipientName: "Nom du destinataire (facultatif)",
      message: "Votre message (facultatif)",
      cta: "Offrir ce chèque cadeau",
      processing: "Redirection vers le paiement…",
      validity: "Valable 12 mois. À présenter lors de la réservation ou à l'accueil du domaine.",
      securePay: "Paiement sécurisé par carte bancaire",
      howtoTitle: "Comment ça marche ?",
      howto: ["Choisissez le montant et personnalisez le message", "Réglez en ligne en toute sécurité", "Recevez votre bon cadeau en PDF, prêt à offrir", "Votre proche le présente lors de sa réservation"],
      requiredError: "Merci d'indiquer votre nom et votre e-mail.",
    },
    giftSuccess: {
      checking: "Vérification de votre paiement…",
      title: "Votre chèque cadeau est prêt !",
      thanks: "Merci pour votre achat. Voici votre bon cadeau, prêt à offrir.",
      amount: "Montant", recipient: "Destinataire", code: "Code", validUntil: "Valable jusqu'au",
      download: "Télécharger le bon cadeau (PDF)",
      emailNote: "Un exemplaire vous sera aussi envoyé par e-mail.",
      pending: "Paiement en cours de vérification. Votre bon cadeau sera disponible dès confirmation.",
      error: "Le paiement n'a pas pu être confirmé. Aucun montant n'a été débité en cas d'échec.",
      home: "Retour à l'accueil",
    },
    socialProof: {
      title: "Ils nous ont fait confiance",
      subtitle: "Plus de 400 voyageurs ont déjà séjourné au domaine",
      booking: "sur Booking.com", google: "sur Google", reviews: "avis", outOf: "sur",
    },
    common: {
      book: "Réserver", bookStay: "Réserver un séjour", organizeSeminar: "Organiser un séminaire",
      seeAvailability: "Voir les disponibilités", checkAvailability: "Vérifier les disponibilités",
      seeAccommodation: "Voir le logement", discover: "Découvrir", requestQuote: "Demander un devis",
      contactDomain: "Contacter le domaine", from: "à partir de", perNight: "/ nuit", deposit: "Caution", depositNote: "restituée après le séjour",
      guests: "voyageurs", arrival: "Arrivée", departure: "Départ", accommodationType: "Type d'hébergement",
      adults: "Adultes", children: "Enfants",
      any: "Tous", search: "Rechercher", capacity: "Capacité", surface: "Superficie",
      beds: "Couchages", people: "pers.", loading: "Chargement…", send: "Envoyer",
      backHome: "Retour à l'accueil", allRooms: "Découvrir les chambres", allGites: "Découvrir les gîtes",
      seeMore: "En savoir plus", night: "nuit", chambre: "Chambre d'hôtes", gite: "Gîte",
    },
    hero: {
      title: "Le Domaine de La Bégaudière",
      subtitle: "Gîtes, chambres d'hôtes et séminaires au cœur de la baie du Mont-Saint-Michel",
      text: "Une parenthèse authentique entre campagne bretonne, Mont-Saint-Michel, Saint-Malo et Cancale.",
      badges: ["Chambres & gîtes climatisés", "Wi-Fi gratuit", "Parking gratuit"],
    },
    welcome: {
      title: "Bienvenue au Domaine de La Bégaudière",
      p1: "À quelques minutes de Dol-de-Bretagne, le Domaine de La Bégaudière vous accueille dans un environnement calme et verdoyant, au cœur de la baie du Mont-Saint-Michel.",
      p2: "Que vous voyagiez en couple, en famille, entre amis ou dans le cadre d'un séjour professionnel, vous pourrez choisir parmi nos cinq chambres d'hôtes et nos deux gîtes.",
      p3: "Le domaine est également adapté à l'organisation de séminaires, de réunions, de journées d'étude et de séjours en groupe.",
      gites: "gîtes", chambres: "chambres d'hôtes", capacity: "personnes environ",
    },
    choose: {
      title: "Choisissez votre séjour",
      c1t: "Les chambres d'hôtes",
      c1x: "Des chambres confortables et chaleureuses, avec salle d'eau privative et petit déjeuner inclus.",
      c2t: "Les gîtes",
      c2x: "Deux gîtes indépendants pour profiter librement de votre séjour en famille ou entre amis.",
      c3t: "Séminaires et groupes",
      c3x: "Un cadre paisible et dépaysant pour réunir vos collaborateurs, organiser une réunion ou accueillir un groupe.",
    },
    services: {
      title: "Les services du domaine",
      subtitle: "Tout le confort d'une demeure bretonne de caractère",
      list: [
        "Chambres & gîtes climatisés", "Parking gratuit", "Accès Wi-Fi", "Chambres familiales", "Linge de lit",
        "Petit déjeuner inclus (chambres d'hôtes)", "Bar", "Salles d'eau privatives",
        "Environnement calme", "Accueil des groupes", "Proximité des sites touristiques",
      ],
    },
    selection: { title: "Nos hébergements", subtitle: "Une sélection de chambres et de gîtes pour votre séjour" },
    seminarSection: {
      title: "Réunissez-vous autrement",
      p1: "Organisez votre séminaire dans un domaine de caractère, loin de l'agitation quotidienne. La Bégaudière permet de réunir travail, hébergement et convivialité dans un même lieu.",
      p2: "Nous étudions chaque projet afin de proposer une formule adaptée au nombre de participants, à la durée du séjour et aux prestations souhaitées.",
      formats: ["Journée d'étude", "Réunion d'équipe", "Séminaire résidentiel", "Séjour de cohésion", "Privatisation pour groupe", "Accueil d'associations et groupes"],
      cta: "Recevoir une proposition personnalisée",
    },
    regionSection: {
      title: "Entre Mont-Saint-Michel et côte d'Émeraude",
      text: "Le Domaine de La Bégaudière constitue un point de départ idéal pour découvrir les grands sites de la baie du Mont-Saint-Michel et de la côte d'Émeraude.",
      cta: "Découvrir la région",
    },
    reviews: { title: "Ils ont séjourné au domaine", subtitle: "Les avis de nos voyageurs" },
    gallery: { title: "Galerie", subtitle: "Un aperçu du domaine et de ses environs" },
    finalCta: {
      title: "Votre séjour en Bretagne commence ici",
      subtitle: "Réservez dès maintenant votre parenthèse au cœur de la baie du Mont-Saint-Michel.",
      b1: "Voir les disponibilités", b2: "Découvrir les hébergements", b3: "Contacter le domaine",
    },
    chambresPage: {
      title: "Nos chambres d'hôtes à Mont-Dol",
      intro: "Posez vos valises dans l'une de nos cinq chambres d'hôtes à Mont-Dol, à deux pas de Dol-de-Bretagne, et profitez d'un séjour reposant au cœur de la baie du Mont-Saint-Michel. À moins de 30 minutes du Mont-Saint-Michel, de Saint-Malo et de Cancale, chaque chambre climatisée dispose de son propre univers, d'une salle d'eau privative et des équipements nécessaires à un séjour confortable. Le petit déjeuner maison et le linge de lit sont inclus.",
      breakfast: "Le petit déjeuner",
      breakfastText: "Commencez la journée en douceur autour d'un petit déjeuner servi au domaine. Boissons chaudes, pains, viennoiseries et produits sélectionnés vous attendent avant de partir à la découverte de la région.",
      mealsTag: "Table d'hôtes",
      mealsTitle: "Les bocaux, en partenariat avec La Cuisine de Mon Père",
      mealsText: "Pour les voyageurs des chambres d'hôtes, nous proposons « Les bocaux », en partenariat avec La Cuisine de Mon Père : une cuisine actuelle et originale, préparée avec des produits frais, locaux et de saison. La table d'hôtes est servie le soir, sur réservation, autour d'une table partagée, et réservée aux personnes hébergées au domaine.",
      mealEntree: "Entrée", mealEntreePrice: "7 €",
      mealPlat: "Plat", mealPlatPrice: "13 €",
      mealDessert: "Dessert", mealDessertPrice: "7 €",
      picnicTitle: "Le midi : formule sandwich / panier", picnicText: "Le midi, nous proposons une formule sandwich ou un panier pique-nique, idéale pour une pause sur le GR 34.",
      seoTitle: "Des chambres d'hôtes de charme à Mont-Dol, aux portes du Mont-Saint-Michel",
      seoP1: "Idéalement situées à Mont-Dol (35120), nos chambres d'hôtes sont le point de départ parfait pour explorer la baie du Mont-Saint-Michel. En quelques minutes, vous rejoignez Dol-de-Bretagne et sa cathédrale, la cité corsaire de Saint-Malo, le port de Cancale et ses huîtres, ou encore le célèbre Mont-Saint-Michel.",
      seoP2: "Que vous voyagiez en couple, en famille ou entre amis, nos cinq chambres d'hôtes offrent calme, confort et authenticité dans une maison de caractère entourée d'un parc arboré. Chaque matin, un petit déjeuner fait maison, préparé avec des produits locaux et de saison, est servi au domaine.",
      seoP3: "Randonneurs sur le sentier des douaniers (GR 34), amateurs de patrimoine breton ou voyageurs en quête de nature : réservez vos chambres d'hôtes à Mont-Dol en direct, au meilleur prix garanti et sans commission.",
      nearbyTitle: "À proximité de nos chambres d'hôtes",
    },
    gitesPage: {
      title: "Nos gîtes à Mont-Dol, au cœur de la baie du Mont-Saint-Michel",
      intro: "Nos deux gîtes de charme à Mont-Dol, tout confort, climatisés et entièrement indépendants, vous accueillent au cœur de la baie du Mont-Saint-Michel, à quelques minutes de Dol-de-Bretagne, Saint-Malo et Cancale. L'adresse idéale pour un week-end, des vacances en famille ou un séjour nature en Bretagne.",
      seoTitle: "Des gîtes de charme à Mont-Dol, au cœur de la baie du Mont-Saint-Michel",
      seoP1: "Situés à Mont-Dol (35120), nos gîtes indépendants sont le camp de base idéal pour découvrir la baie du Mont-Saint-Michel. En quelques minutes, vous rejoignez Dol-de-Bretagne, la cité corsaire de Saint-Malo, le port ostréicole de Cancale et le mythique Mont-Saint-Michel.",
      seoP2: "Parfaits pour les familles et les groupes d'amis, nos gîtes tout confort offrent cuisine équipée, espaces de vie lumineux et un cadre paisible dans un parc arboré. Idéals pour un week-end, des vacances scolaires ou un long séjour nature en Bretagne.",
      seoP3: "Randonnée sur le GR 34, gastronomie bretonne, plages de la Côte d'Émeraude : réservez votre gîte à Mont-Dol en direct, au meilleur prix garanti et sans commission d'intermédiaire.",
      nearbyTitle: "À proximité de nos gîtes",
    },
    seminarPage: {
      title: "Séminaires d'entreprise & formations",
      subtitle: "Réunissez vos équipes et privatisez tout le domaine, à proximité de Saint-Malo et du Mont-Saint-Michel.",
      s1t: "Un domaine entièrement privatisable pour vos équipes",
      s1x: "Le Domaine de La Bégaudière accueille entreprises, organismes de formation et groupes professionnels dans un cadre calme, chaleureux et facilement accessible. Espace de réunion, activités de cohésion et surtout des hébergements sur place : l'endroit idéal pour un séminaire résidentiel ou une formation en immersion, loin des distractions.",
      privatTitle: "Privatisez l'ensemble du domaine",
      privatText: "Pour vos séminaires et formations, réservez le domaine rien que pour votre groupe : les 5 chambres d'hôtes et, si besoin, les 2 gîtes, pour héberger toute votre équipe au même endroit. Un lieu exclusif, un cadre naturel et un vrai esprit de cohésion.",
      privatStats: [
        { n: "5", l: "chambres d'hôtes" },
        { n: "2", l: "gîtes" },
        { n: "24", l: "personnes hébergées" },
      ],
      privatItems: ["Domaine privatisé pour votre groupe", "5 chambres d'hôtes + 2 gîtes", "Grande salle commune (réunions & espace de vie)", "Paniers pique-nique & plats cuisinés à emporter", "Environnement calme et verdoyant", "Parking gratuit sur place", "Activités de cohésion en Bretagne", "Wi-Fi gratuit"],
      typesTitle: "Vos événements professionnels",
      types: ["Séminaire d'entreprise", "Formation", "Séminaire résidentiel", "Journée d'étude", "Comité de direction", "Réunion", "Team building / cohésion", "Convention d'équipe"],
      prestaTitle: "Prestations possibles",
      presta: ["Privatisation du domaine", "Grande salle commune du gîte", "Vidéoprojecteur", "Écran", "Paperboard", "Wi-Fi", "Disposition de salle", "Paniers pique-nique", "Plats cuisinés à emporter", "Hébergement (chambres + gîtes)", "Activités de cohésion", "Bar"],
      prestaNote: "Chaque prestation est étudiée selon votre projet et confirmée avec vous avant validation.",
      formTitle: "Demande de devis",
      formSubtitle: "Décrivez votre projet (formation, séminaire, privatisation), nous revenons vers vous avec une proposition personnalisée.",
    },
    domainePage: {
      title: "Le Domaine",
      subtitle: "Une demeure bretonne de caractère au cœur de la baie",
      ownersTag: "Vos hôtes",
      ownersTitle: "François et Jessica vous accueillent",
      ownersLead: "Une famille, une maison, et l'envie de la partager.",
      ownersText: "Derrière le Domaine de La Bégaudière, il y a avant tout une famille. François et Jessica ont posé leurs valises dans cette demeure bretonne avec l'envie de partager un lieu qu'ils aiment. Parents de quatre enfants, ils connaissent la valeur d'un accueil chaleureux, d'un vrai moment de repos et d'une table conviviale. C'est cet esprit familial, simple et sincère, qu'ils mettent chaque jour au service de vos séjours, que vous veniez en couple, en famille, entre amis ou pour un séminaire.",
      ownersSignature: "François et Jessica, avec leurs quatre enfants",
      p1: "Installée dans un bâtiment en pierres, le long de la paisible rivière du Guyoult, La Bégaudière est un lieu de séjour à taille humaine où l'on vient pour se retrouver, se reposer et découvrir la Bretagne. Le domaine réunit chambres d'hôtes, gîtes et espaces d'accueil pour les groupes dans un environnement calme et authentique.",
      p2: "Notre ambition est de proposer un accueil chaleureux, des hébergements confortables et une expérience simple, conviviale et sincère.",
      whyTitle: "Pourquoi choisir La Bégaudière ?",
      why: ["Un cadre calme et verdoyant", "À proximité des grands sites de la baie", "Chambres d'hôtes et gîtes réunis", "Idéal pour les familles et les groupes", "Adapté aux séminaires", "Un accueil chaleureux et personnalisé"],
      breakfastTitle: "Le petit déjeuner",
      breakfastText: "Un moment convivial pour bien commencer la journée, avec boissons chaudes, pains et viennoiseries.",
      barTitle: "Le bar",
      barText: "Un espace convivial pour se retrouver en fin de journée dans une ambiance détendue.",
      gameTitle: "La salle de jeux",
      gameText: "Billard et baby-foot dans une salle chaleureuse aux murs de pierre, parfait pour des moments en famille ou entre amis, quelle que soit la météo.",
      histoireTag: "Notre histoire",
      histoireTitle: "Un lieu à taille humaine",
      spacesTag: "La vie au domaine",
      spacesTitle: "Les espaces à vivre",
      spacesLead: "Des lieux conviviaux pensés pour se retrouver et se détendre.",
      galleryTitle: "Le domaine en images",
    },
    regionPage: {
      title: "La région",
      subtitle: "Entre Mont-Saint-Michel et côte d'Émeraude",
      intro: "Le Domaine de La Bégaudière constitue un point de départ idéal pour découvrir les grands sites de la baie du Mont-Saint-Michel et de la côte d'Émeraude.",
      labelText: "Une destination labellisée Tourisme Bretagne",
      distance: "Distance", duration: "Temps de trajet", officialSite: "Site officiel",
      thingsToDo: "Que faire sur place ?", fromDomain: "depuis le domaine",
      gr34Tag: "Randonnée · Sentier des douaniers",
      gr34Title: "Au pied du GR 34",
      gr34P1: "Le Domaine de La Bégaudière se trouve au pied du GR 34, le célèbre « sentier des douaniers » qui longe tout le littoral breton. Depuis le domaine, vous rejoignez à pied la baie du Mont-Saint-Michel et la côte d'Émeraude, au fil des marées et des grands paysages.",
      gr34P2: "Randonneurs, vous êtes ici chez vous. Nous accueillons avec plaisir les marcheurs, le temps d'une étape ou d'un séjour, avec un hébergement confortable pour récupérer et de bons conseils pour préparer vos itinéraires.",
      etapeText: "Étape référencée itirando.bzh sur le Sentier des Douaniers.",
      gr34Points: [
        "Accès au GR 34 depuis le domaine",
        "Étapes vers le Mont-Saint-Michel, Cancale et Saint-Malo",
        "Boucles à la journée ou itinérance sur plusieurs jours",
        "Un accueil pensé pour les randonneurs",
      ],
      destinationsTitle: "Les incontournables autour du domaine",
      activitiesTitle: "Que faire dans les environs ?",
      activitiesSubtitle: "Nature, patrimoine, sports et saveurs à portée de main",
      activities: [
        ["Randonnée · GR 34", "Le sentier des douaniers, au pied du domaine.", "Sur place"],
        ["Tennis", "Courts de tennis à proximité immédiate.", "1 km"],
        ["Golf", "Parcours de golf dans les environs.", "10 km"],
        ["Balade à cheval", "Randonnées équestres le long du littoral et dans l'arrière-pays.", "10 km"],
        ["Char à voile", "Sensations garanties sur les grandes plages de la baie.", ""],
        ["Plages", "Les plages de sable fin de la côte d'Émeraude.", ""],
        ["Vélo", "Voies vertes et petites routes de campagne pour explorer la baie.", ""],
        ["Marchés", "Les marchés bretons de Dol-de-Bretagne et des alentours.", ""],
        ["Restaurants", "Crêperies, produits de la mer et bonnes tables du terroir.", ""],
        ["En famille", "Découvertes nature et sorties adaptées aux enfants.", ""],
      ],
      nearbyTitle: "Les lieux du coin",
      nearbyText: "Autour du domaine, à Mont-Dol et Dol-de-Bretagne, et un peu plus loin : le Mont-Saint-Michel, Cancale, Saint-Malo, Dinan et Dinard.",
      ctaTitle: "Envie de partir à la découverte de la Bretagne ?",
      ctaText: "Posez vos valises au domaine et rayonnez dans toute la baie.",
    },
    infosPage: {
      title: "Informations pratiques",
      subtitle: "Tout ce qu'il faut savoir avant votre séjour",
      faqTitle: "Questions fréquentes",
      sections: [
        ["Arrivée et départ", "Arrivée pour les gîtes de 16h à 20h. Arrivée pour les chambres d'hôtes de 17h à 19h. Les horaires de départ vous sont précisés lors de la confirmation de votre réservation."],
        ["Adresse et itinéraire", "12 La Bégaudière, 35120 Mont-Dol. Le domaine est facilement accessible en voiture, à proximité de Dol-de-Bretagne."],
        ["Parking", "Un parking gratuit est disponible sur place."],
        ["Petit déjeuner", "Le petit déjeuner est inclus pour les chambres d'hôtes."],
        ["Linge", "Le linge de lit est inclus dans les chambres d'hôtes et fourni dans les gîtes."],
        ["Enfants et familles", "Le domaine accueille les familles ; les chambres familiales peuvent accueillir jusqu'à 5 personnes. Lit bébé ou lit parapluie fournis sur demande."],
        ["Animaux", "Les animaux ne sont pas acceptés au domaine."],
        ["Paiement et annulation", "Les modes de paiement et conditions d'annulation vous sont précisés lors de la réservation."],
      ],
    },
    contactPage: {
      title: "Contact",
      subtitle: "Une question, une demande ? Écrivez-nous.",
      categories: ["Réservation", "Chambre d'hôtes", "Gîte", "Séminaire", "Groupe", "Question générale", "Partenariat"],
      access: {
        title: "Accès & itinéraire",
        subtitle: "Au cœur de la baie du Mont-Saint-Michel, facilement accessible en voiture comme en train.",
        carTitle: "En voiture",
        carText: "Depuis Rennes ou Caen, empruntez la N176 puis la sortie Dol-de-Bretagne. Parking gratuit sur place.",
        trainTitle: "En train",
        trainText: "Gare de Dol-de-Bretagne à 2 min (≈ 2 km) : TGV InOui direct depuis Paris-Montparnasse (via Rennes) et ligne TER Rennes ↔ Saint-Malo. Transfert depuis la gare possible sur demande.",
        planeTitle: "En avion",
        planeText: "Aéroport de Rennes–Saint-Jacques à ≈ 1 h (≈ 60 km).",
        gps: "Coordonnées GPS",
        itinerary: "Ouvrir l'itinéraire",
        badge: "Nous rejoindre",
      },
    },
    searchPage: {
      title: "Disponibilités",
      resultsFor: "hébergement(s) correspondant à votre recherche",
      noResults: "Aucun hébergement ne correspond à ces critères. Modifiez votre recherche ou contactez-nous.",
      requestBooking: "Demander à réserver",
    },
    bookingForm: {
      title: "Demande de réservation", name: "Nom", email: "E-mail", phone: "Téléphone",
      message: "Message", success: "Votre demande a bien été envoyée. Nous vous recontactons rapidement.",
      cleaningFee: "Frais de ménage", cleaningFeeNote: "ajoutés au séjour",
      lateCheckout: "Départ tardif jusqu'à 13h", extras: "Options et frais",
      pet: "Animal de compagnie", petNote: "forfait par séjour",
      tableHotes: "Table d'hôtes « Les bocaux »", tableHotesNote: "Entrée 7 € · Plat 13 € · Dessert 7 €, par soir",
      bocaux: "Table d'hôtes « Les bocaux »", bocauxNote: "à régler sur place, sur réservation",
      bocauxEntree: "Entrée", bocauxPlat: "Plat", bocauxDessert: "Dessert", bocauxEstimate: "Estimation (réglée sur place)",
      picnic: "Panier pique-nique", picnicNote: "8 €/pers., le midi",
      insurance: "Assurance annulation (facultative)",
      insuranceDesc: "Remboursement des sommes versées pour le séjour (hors coût de l'assurance), sur présentation d'un justificatif officiel, dans ces seuls cas :",
      insuranceCase1: "Décès du titulaire de la réservation",
      insuranceCase2: "Hospitalisation imprévue du titulaire de la réservation",
      insuranceExclusion: "Aucun autre motif n'est couvert. Sans cette assurance, aucun remboursement n'est possible à 30 jours ou moins de l'arrivée.",
      chooseAccommodation: "Choisir un logement",
      summary: "Récapitulatif", subtotal: "Séjour", total: "Total du séjour",
      depositNow: "Acompte à régler maintenant (30 %)", balance: "Solde à régler sur place (espèces ou CB)",
      cautionLine: "Caution (empreinte sur place)",
      touristTax: "Taxe de séjour (sur place)",
      address: "Adresse", addressPh: "N° et rue", postalCode: "Code postal", city: "Ville", country: "Pays",
      paymentNote: "Le solde, la taxe de séjour et la caution se règlent uniquement sur place, en espèces ou par carte bancaire.",
      cancellation: "Annulation gratuite jusqu'à 30 jours avant l'arrivée.",
      payDeposit: "Payer l'acompte et réserver", unavailable: "Ces dates ne sont pas disponibles.",
      selectDates: "Sélectionnez vos dates pour voir le tarif.", nights: "nuit(s)",
      calendarPick: "Choisissez vos dates disponibles",
      unavailableLegend: "Indisponible",
      rangeUnavailable: "Certaines nuits sont déjà réservées. Choisissez une autre période.",
      computing: "Calcul en cours…",
      acceptTerms: "J'ai lu et j'accepte les",      acceptTermsCgv: "conditions générales de vente",
      acceptTermsAnd: "et la",
      acceptTermsCancellation: "politique d'annulation",
      viewContract: "consulter le contrat",
      noShowNotice: "🔒 Vos coordonnées bancaires sont conservées de façon sécurisée par notre prestataire de paiement (Stripe). En cas de non-présentation (no-show), le solde du séjour pourra être prélevé sur cette carte, conformément à nos conditions d'annulation.",
      termsRequired: "Vous devez accepter les CGV et la politique d'annulation pour réserver.",
    },
    form: {
      nom: "Nom", prenom: "Prénom", entreprise: "Entreprise", email: "E-mail", telephone: "Téléphone",
      objet: "Objet", categorie: "Catégorie", message: "Message", consent: "J'accepte que mes données soient utilisées pour traiter ma demande (RGPD).",
      typeEvenement: "Type d'événement", dateSouhaitee: "Date souhaitée", dateFlexible: "Dates flexibles",
      participants: "Nombre de participants", hebergement: "Personnes à héberger", nuits: "Nombre de nuits",
      repas: "Repas souhaités", equipements: "Équipements souhaités", budget: "Budget indicatif",
      budgetHint: "Indiquer une fourchette nous aide à vous proposer une offre parfaitement adaptée.",
      budgetOptions: ["Moins de 500 €", "500 à 1 000 €", "1 000 à 1 500 €", "Plus de 1 500 €", "À définir ensemble"],
      commentaire: "Commentaire", required: "Ce champ est requis",
      contactSuccess: "Merci ! Votre message a bien été envoyé.",
      quoteSuccess: "Merci ! Votre demande de devis a bien été envoyée. Nous revenons vers vous rapidement.",
    },
    footer: {
      tagline: "Gîtes, chambres d'hôtes et séminaires au cœur de la baie du Mont-Saint-Michel.",
      contact: "Contact", hours: "Horaires d'accueil", follow: "Suivez-nous", legal: "Informations légales",
      mentions: "Mentions légales", privacy: "Politique de confidentialité", cgv: "Conditions générales de vente",
      cancellation: "Politique d'annulation", cookies: "Gestion des cookies", rights: "Tous droits réservés",
      nav: "Navigation", siret: "SIRET", labels: "Labels & partenaires",
    },
    cookie: {
      text: "Ce site utilise uniquement des cookies strictement nécessaires à son bon fonctionnement. Aucun cookie de suivi publicitaire ni de mesure d'audience n'est déposé.",
      accept: "J'ai compris", refuse: "En savoir plus",
    },
  },

  en: {
    nav: {
      home: "Home", chambres: "Guest rooms", gites: "Cottages",
      seminaires: "Seminars and groups", domaine: "The Estate", region: "The region",
      infos: "Practical info", contact: "Contact", reserver: "Book", sejours: "Our stays",
      giftcards: "Gift cards", boutique: "Shop",
    },
    boutiquePage: {
      tag: "Estate shop",
      title: "A shop corner with the colours of Brittany",
      subtitle: "Take home a piece of Brittany: local treats and little souvenirs, on sale at the estate reception.",
      note: "On sale on site, at the estate reception",
      empty: "Our selection is coming very soon.",
      allCategories: "All",
    },
    packages: {
      title: "Stays to experience", subtitle: "Experiences designed for you",
      from: "from", cta: "Book this stay", included: "Included",
      items: [
        { title: "Romantic getaway", tagline: "A peaceful escape for two in the bay.",
          includes: ["1 to 2 nights in a cosy room", "Breakfast", "Gourmet basket", "Sunset walk ideas"] },
        { title: "GR34 hiking weekend", tagline: "The coastal path starting from the estate.",
          includes: ["Night(s) at the estate", "Breton picnic basket", "Recommended GR34 routes", "Late checkout available"] },
        { title: "Mont-Saint-Michel stay", tagline: "Discover the Wonder of the West.",
          includes: ["Accommodation in the heart of the bay", "Tide schedule advice", "Best spots to visit", "Free on-site parking"] },
      ],
    },
    badges: {
      title: "Our commitments",
      items: ["Homemade breakfast", "Local produce", "Free Wi-Fi", "Free parking"],
    },
    directBanner: {
      text: "Book direct, best price guaranteed, no commission",
      badge: "up to -20% vs Airbnb & Booking",
    },
    reassurance: {
      items: ["Free cancellation (conditions apply)", "Instant confirmation", "100% secure payment"],
    },
    onsite: {
      tag: "Life at La Bégaudière",
      title: "A little shop corner on site",
      text: "The estate is also a place that lives. At reception, discover a selection of Breton local produce, creations from local artisans and small souvenirs to take home, to keep a little bit of Brittany with you after your stay.",
      items: ["Breton local produce", "Local artisan creations", "Souvenirs of the bay", "Gift ideas"],
      note: "Available on site, at the estate reception.",
    },
    bikeRental: {
      tag: "On site",
      title: "Bike rental",
      text: "Explore the Bay of Mont-Saint-Michel and the country lanes at your own pace. We rent out adult and child bikes right at the estate, perfect for a family ride to the marshes or towards Dol-de-Bretagne.",
      adult: "Adult bike",
      child: "Child bike",
      halfDay: "Half day",
      fullDay: "Full day",
      adultHalf: "€10", adultFull: "€15",
      childHalf: "€10", childFull: "€13",
      note: "Booked on site, subject to availability. Helmet optional: €5 / day.",
    },
    giftPage: {
      title: "Give the gift of a stay",
      subtitle: "The perfect present for your loved ones",
      crumb: "Gift cards",
      intro: "Offer a relaxing break at Domaine de La Bégaudière. Choose an amount, personalise your message: the gift card is available instantly as a PDF, ready to give.",
      chooseAmount: "Choose an amount",
      customAmount: "Other amount (custom)",
      customPlaceholder: "Enter an amount",
      customError: "Amount between {min} and {max} €",
      buyerName: "Your name", buyerEmail: "Your email",
      recipientName: "Recipient's name (optional)",
      message: "Your message (optional)",
      cta: "Offer this gift card",
      processing: "Redirecting to payment…",
      validity: "Valid for 12 months. To be presented when booking or at the estate reception.",
      securePay: "Secure card payment",
      howtoTitle: "How it works",
      howto: ["Choose the amount and personalise the message", "Pay securely online", "Receive your gift card as a PDF, ready to give", "Your loved one presents it when booking"],
      requiredError: "Please provide your name and email.",
    },
    giftSuccess: {
      checking: "Checking your payment…",
      title: "Your gift card is ready!",
      thanks: "Thank you for your purchase. Here is your gift card, ready to give.",
      amount: "Amount", recipient: "Recipient", code: "Code", validUntil: "Valid until",
      download: "Download gift card (PDF)",
      emailNote: "A copy will also be sent to you by email.",
      pending: "Payment is being verified. Your gift card will be available once confirmed.",
      error: "The payment could not be confirmed. No amount was charged if it failed.",
      home: "Back to home",
    },
    socialProof: {
      title: "Trusted by our guests",
      subtitle: "Over 400 travellers have already stayed at the estate",
      booking: "on Booking.com", google: "on Google", reviews: "reviews", outOf: "out of",
    },
    common: {
      book: "Book", bookStay: "Book a stay", organizeSeminar: "Organise a seminar",
      seeAvailability: "See availability", checkAvailability: "Check availability",
      seeAccommodation: "View accommodation", discover: "Discover", requestQuote: "Request a quote",
      contactDomain: "Contact the estate", from: "from", perNight: "/ night", deposit: "Security deposit", depositNote: "refunded after your stay",
      guests: "guests", arrival: "Check-in", departure: "Check-out", accommodationType: "Accommodation type",
      adults: "Adults", children: "Children",
      any: "All", search: "Search", capacity: "Capacity", surface: "Area",
      beds: "Beds", people: "pers.", loading: "Loading…", send: "Send",
      backHome: "Back to home", allRooms: "Discover the rooms", allGites: "Discover the cottages",
      seeMore: "Learn more", night: "night", chambre: "Guest room", gite: "Cottage",
    },
    hero: {
      title: "Domaine de La Bégaudière",
      subtitle: "Cottages, guest rooms and seminars in the heart of the Mont-Saint-Michel bay",
      text: "An authentic escape between the Breton countryside, Mont-Saint-Michel, Saint-Malo and Cancale.",
      badges: ["Air-conditioned rooms & cottages", "Free Wi-Fi", "Free parking"],
    },
    welcome: {
      title: "Welcome to Domaine de La Bégaudière",
      p1: "A few minutes from Dol-de-Bretagne, Domaine de La Bégaudière welcomes you in a calm, green setting in the heart of the Mont-Saint-Michel bay.",
      p2: "Whether you travel as a couple, family, with friends or for business, choose from our five guest rooms and two cottages.",
      p3: "The estate is also perfect for seminars, meetings, study days and group stays.",
      gites: "cottages", chambres: "guest rooms", capacity: "people approx.",
    },
    choose: {
      title: "Choose your stay",
      c1t: "The guest rooms",
      c1x: "Comfortable, warm rooms with private bathroom and breakfast included.",
      c2t: "The cottages",
      c2x: "Two independent cottages to enjoy your stay freely with family or friends.",
      c3t: "Seminars and groups",
      c3x: "A peaceful setting to bring your team together, hold a meeting or welcome a group.",
    },
    services: {
      title: "Estate services",
      subtitle: "All the comfort of a characterful Breton house",
      list: [
        "Air-conditioned rooms & cottages", "Free parking", "Wi-Fi access", "Family rooms", "Bed linen",
        "Breakfast included (guest rooms)", "Bar", "Private bathrooms",
        "Peaceful setting", "Group welcome", "Close to tourist sites",
      ],
    },
    selection: { title: "Our accommodations", subtitle: "A selection of rooms and cottages for your stay" },
    seminarSection: {
      title: "Meet differently",
      p1: "Hold your seminar in a characterful estate, away from daily hustle. La Bégaudière combines work, accommodation and conviviality in one place.",
      p2: "We study every project to offer a formula tailored to the number of participants, length of stay and desired services.",
      formats: ["Study day", "Team meeting", "Residential seminar", "Team-building stay", "Group privatisation", "Associations and groups"],
      cta: "Get a tailored proposal",
    },
    regionSection: {
      title: "Between Mont-Saint-Michel and the Emerald Coast",
      text: "Domaine de La Bégaudière is an ideal starting point to explore the great sites of the Mont-Saint-Michel bay and the Emerald Coast.",
      cta: "Discover the region",
    },
    reviews: { title: "They stayed at the estate", subtitle: "What our guests say" },
    gallery: { title: "Gallery", subtitle: "A glimpse of the estate and its surroundings" },
    finalCta: {
      title: "Your stay in Brittany begins here",
      subtitle: "Book your escape in the heart of the Mont-Saint-Michel bay now.",
      b1: "See availability", b2: "Discover accommodations", b3: "Contact the estate",
    },
    chambresPage: {
      title: "Our guest rooms in Mont-Dol",
      intro: "Settle into one of our five guest rooms in Mont-Dol, just a stone's throw from Dol-de-Bretagne, and enjoy a restful stay in the heart of the Bay of Mont-Saint-Michel. Less than 30 minutes from Mont-Saint-Michel, Saint-Malo and Cancale, each air-conditioned room has its own character, a private bathroom and everything you need for a comfortable stay. Homemade breakfast and bed linen are included.",
      breakfast: "Breakfast",
      breakfastText: "Start the day gently with a breakfast served at the estate. Hot drinks, breads, pastries and selected products await before you set off to explore the region.",
      mealsTag: "Table d'hôtes",
      mealsTitle: "'Les bocaux', in partnership with La Cuisine de Mon Père",
      mealsText: "For guest-room travellers, we offer 'Les bocaux', in partnership with La Cuisine de Mon Père: modern, original cuisine prepared with fresh, local and seasonal produce. The table d'hôtes is served in the evening, by reservation, around a shared table, and reserved for guests staying at the estate.",
      mealEntree: "Starter", mealEntreePrice: "€7",
      mealPlat: "Main", mealPlatPrice: "€13",
      mealDessert: "Dessert", mealDessertPrice: "€7",
      picnicTitle: "Lunch: sandwich / picnic option", picnicText: "At lunchtime, we offer a sandwich formula or a picnic basket, ideal for a break on the GR 34.",
      seoTitle: "Charming guest rooms in Mont-Dol, at the gateway to Mont-Saint-Michel",
      seoP1: "Perfectly located in Mont-Dol (35120), our guest rooms are the ideal starting point to explore the Bay of Mont-Saint-Michel. Within minutes you can reach Dol-de-Bretagne and its cathedral, the corsair city of Saint-Malo, the oyster port of Cancale, or the famous Mont-Saint-Michel itself.",
      seoP2: "Whether you travel as a couple, with family or with friends, our five guest rooms offer peace, comfort and authenticity in a house of character surrounded by wooded grounds. Every morning, a homemade breakfast made with local, seasonal produce is served at the estate.",
      seoP3: "Hikers on the GR 34 coastal path, lovers of Breton heritage or travellers seeking nature: book your guest rooms in Mont-Dol directly, at the best guaranteed rate and commission-free.",
      nearbyTitle: "Near our guest rooms",
    },
    gitesPage: {
      title: "Our cottages in Mont-Dol, in the heart of the Mont-Saint-Michel bay",
      intro: "Our two charming, fully self-contained and air-conditioned cottages in Mont-Dol welcome you in the heart of the Bay of Mont-Saint-Michel, just minutes from Dol-de-Bretagne, Saint-Malo and Cancale. The ideal base for a weekend, a family holiday or a nature getaway in Brittany.",
      seoTitle: "Charming cottages in Mont-Dol, in the heart of the Bay of Mont-Saint-Michel",
      seoP1: "Located in Mont-Dol (35120), our self-contained cottages are the ideal base to discover the Bay of Mont-Saint-Michel. Within minutes you can reach Dol-de-Bretagne, the corsair city of Saint-Malo, the oyster port of Cancale and the legendary Mont-Saint-Michel.",
      seoP2: "Perfect for families and groups of friends, our fully-equipped cottages offer a fitted kitchen, bright living spaces and a peaceful setting in wooded grounds. Ideal for a weekend, school holidays or a longer nature stay in Brittany.",
      seoP3: "Hiking on the GR 34, Breton gastronomy, the beaches of the Emerald Coast: book your cottage in Mont-Dol directly, at the best guaranteed rate and with no middleman commission.",
      nearbyTitle: "Near our cottages",
    },
    seminarPage: {
      title: "Corporate seminars & training",
      subtitle: "Bring your teams together and privatise the whole estate, near Saint-Malo and Mont-Saint-Michel.",
      s1t: "An estate you can fully privatise for your teams",
      s1x: "Domaine de La Bégaudière welcomes companies, training organisations and professional groups in a calm, warm and easily accessible setting. Meeting space, team-building activities and, above all, on-site accommodation: the ideal place for a residential seminar or an immersive training course, away from distractions.",
      privatTitle: "Privatise the entire estate",
      privatText: "For your seminars and training courses, book the estate just for your group: the 5 guest rooms and, if needed, the 2 cottages, to host your whole team in one place. An exclusive venue, a natural setting and a real team spirit.",
      privatStats: [
        { n: "5", l: "guest rooms" },
        { n: "2", l: "cottages" },
        { n: "24", l: "guests hosted" },
      ],
      privatItems: ["Estate privatised for your group", "5 guest rooms + 2 cottages", "Large common room (meetings & living space)", "Picnic baskets & ready-made dishes to take away", "Calm, green environment", "Free on-site parking", "Team-building activities in Brittany", "Free Wi-Fi"],
      typesTitle: "Your professional events",
      types: ["Corporate seminar", "Training", "Residential seminar", "Study day", "Executive committee", "Meeting", "Team building", "Team convention"],
      prestaTitle: "Possible services",
      presta: ["Estate privatisation", "Cottage common room", "Projector", "Screen", "Flipchart", "Wi-Fi", "Room layout", "Picnic baskets", "Ready-made dishes to take away", "Accommodation (rooms + cottages)", "Team-building activities", "Bar"],
      prestaNote: "Each service is studied according to your project and confirmed with you before validation.",
      formTitle: "Quote request",
      formSubtitle: "Describe your project (training, seminar, privatisation) and we'll get back with a tailored proposal.",
    },
    domainePage: {
      title: "The Estate",
      subtitle: "A characterful Breton house in the heart of the bay",
      ownersTag: "Your hosts",
      ownersTitle: "François and Jessica welcome you",
      ownersLead: "A family, a home, and the wish to share it.",
      ownersText: "Behind Domaine de La Bégaudière, there is above all a family. François and Jessica settled into this Breton house with a wish to share a place they love. Parents of four children, they know the value of a warm welcome, real rest and a convivial table. It is this simple, sincere family spirit that they bring to your stays every day, whether you come as a couple, a family, with friends or for a seminar.",
      ownersSignature: "François and Jessica, with their four children",
      p1: "Set in a stone building along the peaceful Guyoult river, La Bégaudière is a human-scale place to reconnect, rest and discover Brittany. The estate brings together guest rooms, cottages and group spaces in a calm, authentic setting.",
      p2: "Our ambition is a warm welcome, comfortable accommodation and a simple, convivial and sincere experience.",
      whyTitle: "Why choose La Bégaudière?",
      why: ["A calm, green setting", "Close to the bay's great sites", "Guest rooms and cottages together", "Ideal for families and groups", "Suited to seminars", "A warm, personal welcome"],
      breakfastTitle: "Breakfast",
      breakfastText: "A convivial moment to start the day, with hot drinks, breads and pastries.",
      barTitle: "The bar",
      barText: "A convivial space to gather at the end of the day in a relaxed atmosphere.",
      gameTitle: "The games room",
      gameText: "Pool table and table football in a warm stone-walled room, perfect for family or friends, whatever the weather.",
      histoireTag: "Our story",
      histoireTitle: "A human-scale place",
      spacesTag: "Life at the estate",
      spacesTitle: "Shared spaces to enjoy",
      spacesLead: "Convivial places designed to gather and relax.",
      galleryTitle: "The estate in pictures",
    },
    regionPage: {
      title: "The region",
      subtitle: "Between Mont-Saint-Michel and the Emerald Coast",
      intro: "Domaine de La Bégaudière is an ideal starting point to explore the great sites of the Mont-Saint-Michel bay and the Emerald Coast.",
      labelText: "A Tourisme Bretagne–labelled destination",
      distance: "Distance", duration: "Travel time", officialSite: "Official site",
      thingsToDo: "What to do there?", fromDomain: "from the estate",
      gr34Tag: "Hiking · Customs officers' path",
      gr34Title: "At the foot of the GR 34",
      gr34P1: "Domaine de La Bégaudière lies at the foot of the GR 34, the famous 'customs officers' path' that runs along the entire Breton coast. From the estate you can reach the Mont-Saint-Michel bay and the Emerald Coast on foot, following the tides and the sweeping landscapes.",
      gr34P2: "Hikers, you'll feel right at home. We warmly welcome walkers for a single stage or a longer stay, with comfortable accommodation to recover and good advice to plan your routes.",
      etapeText: "An itirando.bzh listed stopover on the Customs Officers' Path.",
      gr34Points: [
        "Access to the GR 34 from the estate",
        "Stages towards Mont-Saint-Michel, Cancale and Saint-Malo",
        "Day loops or multi-day trekking",
        "A welcome designed for hikers",
      ],
      destinationsTitle: "The must-sees around the estate",
      activitiesTitle: "What to do nearby?",
      activitiesSubtitle: "Nature, heritage, sports and flavours within easy reach",
      activities: [
        ["Hiking · GR 34", "The customs officers' path, at the foot of the estate.", "On site"],
        ["Tennis", "Tennis courts nearby.", "1 km"],
        ["Golf", "Golf courses in the surroundings.", "10 km"],
        ["Horse riding", "Rides along the coast and inland.", "10 km"],
        ["Sand yachting", "Thrills on the wide beaches of the bay.", ""],
        ["Beaches", "The fine sandy beaches of the Emerald Coast.", ""],
        ["Cycling", "Greenways and quiet country roads to explore the bay.", ""],
        ["Markets", "Breton markets in Dol-de-Bretagne and around.", ""],
        ["Restaurants", "Crêperies, seafood and fine local tables.", ""],
        ["With family", "Nature discoveries and outings for children.", ""],
      ],
      nearbyTitle: "Places around here",
      nearbyText: "Around the estate, in Mont-Dol and Dol-de-Bretagne, and a little further: Mont-Saint-Michel, Cancale, Saint-Malo, Dinan and Dinard.",
      ctaTitle: "Ready to explore Brittany?",
      ctaText: "Settle in at the estate and radiate out across the whole bay.",
    },
    infosPage: {
      title: "Practical information",
      subtitle: "Everything to know before your stay",
      faqTitle: "Frequently asked questions",
      sections: [
        ["Check-in and check-out", "Check-in for the cottages from 4 pm to 8 pm. Check-in for the guest rooms from 5 pm to 7 pm. Check-out times are provided when your booking is confirmed."],
        ["Address and directions", "12 La Bégaudière, 35120 Mont-Dol. Easily reached by car, near Dol-de-Bretagne."],
        ["Parking", "Free parking is available on site."],
        ["Breakfast", "Breakfast is included for guest rooms."],
        ["Linen", "Bed linen is included in guest rooms and provided in cottages."],
        ["Children and families", "The estate welcomes families; family rooms accommodate up to 5 people. Cot or travel cot provided on request."],
        ["Pets", "Pets are not allowed at the estate."],
        ["Payment and cancellation", "Payment methods and cancellation terms are specified at booking."],
      ],
    },
    contactPage: {
      title: "Contact",
      subtitle: "A question or request? Write to us.",
      categories: ["Booking", "Guest room", "Cottage", "Seminar", "Group", "General question", "Partnership"],
      access: {
        title: "Getting here",
        subtitle: "In the heart of the Mont-Saint-Michel bay, easily reached by car or train.",
        carTitle: "By car",
        carText: "From Rennes or Caen, take the N176 then the Dol-de-Bretagne exit. Free parking on site.",
        trainTitle: "By train",
        trainText: "Dol-de-Bretagne station 2 min away (≈ 2 km): direct TGV InOui from Paris-Montparnasse (via Rennes) and Rennes ↔ Saint-Malo TER line. Transfer from the station available on request.",
        planeTitle: "By plane",
        planeText: "Rennes–Saint-Jacques airport ≈ 1 h away (≈ 60 km).",
        gps: "GPS coordinates",
        itinerary: "Open directions",
        badge: "Find us",
      },
    },
    searchPage: {
      title: "Availability",
      resultsFor: "accommodation(s) matching your search",
      noResults: "No accommodation matches these criteria. Adjust your search or contact us.",
      requestBooking: "Request to book",
    },
    bookingForm: {
      title: "Booking request", name: "Name", email: "Email", phone: "Phone",
      message: "Message", success: "Your request has been sent. We'll get back to you shortly.",
      cleaningFee: "Cleaning fee", cleaningFeeNote: "added to the stay",
      lateCheckout: "Late checkout until 1pm", extras: "Options and fees",
      pet: "Pet", petNote: "flat fee per stay",
      tableHotes: "Table d'hôtes 'Les bocaux'", tableHotesNote: "Starter €7 · Main €13 · Dessert €7, per evening",
      bocaux: "Table d'hôtes 'Les bocaux'", bocauxNote: "paid on site, by reservation",
      bocauxEntree: "Starter", bocauxPlat: "Main", bocauxDessert: "Dessert", bocauxEstimate: "Estimate (paid on site)",
      picnic: "Picnic basket", picnicNote: "€8/person, lunch",
      insurance: "Cancellation insurance (optional)",
      insuranceDesc: "Refund of amounts paid for the stay (excluding the insurance cost), upon presentation of an official supporting document, in these cases only:",
      insuranceCase1: "Death of the person who made the booking",
      insuranceCase2: "Unforeseen hospitalisation of the person who made the booking",
      insuranceExclusion: "No other reason is covered. Without this insurance, no refund is possible 30 days or less before arrival.",
      chooseAccommodation: "Choose an accommodation",
      summary: "Summary", subtotal: "Stay", total: "Stay total",
      depositNow: "Deposit due now (30%)", balance: "Balance due on arrival (cash or card)",
      cautionLine: "Security deposit (hold on arrival)",
      touristTax: "Tourist tax (on site)",
      address: "Address", addressPh: "No. and street", postalCode: "Postal code", city: "City", country: "Country",
      paymentNote: "The balance, tourist tax and security deposit are payable on site only, in cash or by card.",
      cancellation: "Free cancellation up to 30 days before arrival.",
      payDeposit: "Pay deposit and book", unavailable: "These dates are not available.",
      selectDates: "Select your dates to see the price.", nights: "night(s)",
      calendarPick: "Choose your available dates",
      unavailableLegend: "Unavailable",
      rangeUnavailable: "Some selected nights are already booked. Please choose another period.",
      computing: "Calculating…",
      acceptTerms: "I have read and accept the",
      acceptTermsCgv: "terms and conditions of sale",
      acceptTermsAnd: "and the",
      acceptTermsCancellation: "cancellation policy",
      viewContract: "view the contract",
      noShowNotice: "🔒 Your card details are securely stored by our payment provider (Stripe). In the event of a no-show, the balance of the stay may be charged to this card, in accordance with our cancellation policy.",
      termsRequired: "You must accept the terms of sale and cancellation policy to book.",
    },
    form: {
      nom: "Last name", prenom: "First name", entreprise: "Company", email: "Email", telephone: "Phone",
      objet: "Subject", categorie: "Category", message: "Message", consent: "I agree that my data may be used to process my request (GDPR).",
      typeEvenement: "Event type", dateSouhaitee: "Preferred date", dateFlexible: "Flexible dates",
      participants: "Number of participants", hebergement: "People to accommodate", nuits: "Number of nights",
      repas: "Meals", equipements: "Equipment", budget: "Indicative budget",
      budgetHint: "Sharing a range helps us tailor the perfect offer for you.",
      budgetOptions: ["Under €500", "€500 – €1,000", "€1,000 – €1,500", "Over €1,500", "To be defined together"],
      commentaire: "Comment", required: "This field is required",
      contactSuccess: "Thank you! Your message has been sent.",
      quoteSuccess: "Thank you! Your quote request has been sent. We'll get back to you shortly.",
    },
    footer: {
      tagline: "Cottages, guest rooms and seminars in the heart of the Mont-Saint-Michel bay.",
      contact: "Contact", hours: "Opening hours", follow: "Follow us", legal: "Legal information",
      mentions: "Legal notice", privacy: "Privacy policy", cgv: "Terms of sale",
      cancellation: "Cancellation policy", cookies: "Cookie settings", rights: "All rights reserved",
      nav: "Navigation", siret: "SIRET", labels: "Labels & partners",
    },
    cookie: {
      text: "This site only uses cookies strictly necessary for its proper functioning. No advertising or audience-measurement tracking cookies are placed.",
      accept: "Got it", refuse: "Learn more",
    },
  },
};

